import config from '@/config/appConfig'

export default {
  prefix: config.nombreApp + '_' + process.env.NODE_ENV.substring(0, 3) + '_',

  setKey (key, item) {
    if (window.localStorage) {
      let data = typeof item === 'object' ? JSON.stringify(item) : item
      window.localStorage.setItem(this.prefix + key, data)
    }
  },
  getKey (key, isObject) {
    if (window.localStorage) {
      let data = window.localStorage.getItem(this.prefix + key)
      return isObject ? JSON.parse(data) : data
    }
    return null
  },
  removeKey (key) {
    if (window.localStorage) {
      window.localStorage.removeItem(this.prefix + key)
    }
  }
}
